module.exports = __webpack_public_path__ + "img/06.c0ab59f3.png";